/**
 * @generated SignedSource<<fca7bed3b55d73413ddb9ef6a5a60f98>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "routes_RentalVehicleMap_Query",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "RentalVehicle",
        "kind": "LinkedField",
        "name": "rentalVehicle",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "RentalVehiclePageMapContainer_rentalVehicle"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "QueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "routes_RentalVehicleMap_Query",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "RentalVehicle",
        "kind": "LinkedField",
        "name": "rentalVehicle",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lat",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lon",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a1ccf28adbfc596373315ab91c111c14",
    "id": null,
    "metadata": {},
    "name": "routes_RentalVehicleMap_Query",
    "operationKind": "query",
    "text": "query routes_RentalVehicleMap_Query(\n  $id: String!\n) {\n  rentalVehicle(id: $id) {\n    ...RentalVehiclePageMapContainer_rentalVehicle\n    id\n  }\n}\n\nfragment RentalVehiclePageMapContainer_rentalVehicle on RentalVehicle {\n  lat\n  lon\n  name\n}\n"
  }
};
})();

node.hash = "bb18eb72794967b5505733e96f871500";

export default node;
